import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CreateProduct } from '../components/Products/CreateProduct'
import { useProduct } from '../hooks/useProduct'

export const CreateProductPage = () => {
  const { productId = null } = useParams<{ productId?: string }>()
  const { product, error: productError } = useProduct(productId)
  const loading = productId && !productError && !product ? true : false

  useEffect(() => {
    if (productError?.response?.status === 404) {
      toast('Product ID does not exist.', { containerId: 'error' })
    }
  }, [productError])

  return <CreateProduct product={product} loading={loading} />
}
